import { RouteConfig } from 'vue-router';
import _ from 'lodash';

import { NAME } from '../constants';
import VyhodnoceniPouzitychPaketu from './VyhodnoceniPouzitychPaketu.vue';
import InformaceoServisuDleNS from './InformaceoServisuDleNS.vue';
import TrzbyNORApodleKoduMarketu from './TrzbyNORApodleKoduMarketu.vue';
import ObratySkladuDlePracovnika from './ObratySkladuDlePracovnika.vue';
import ObratyDilnyDlePracovnika from './ObratyDilnyDlePracovnika.vue';

export const children: RouteConfig[] = _.map([
	{ name: 'VyhodnoceniPouzitychPaketu', path: 'VyhodnoceniPouzitychPaketu', component: VyhodnoceniPouzitychPaketu },
	{ name: 'InformaceoServisuDleNS', path: 'InformaceoServisuDleNS', component: InformaceoServisuDleNS },
	{ name: 'TrzbyNORApodleKoduMarketu', path: 'TrzbyNORApodleKoduMarketu', component: TrzbyNORApodleKoduMarketu },
	{ name: 'ObratySkladuDlePracovnika', path: 'ObratySkladuDlePracovnika', component: ObratySkladuDlePracovnika },
	{ name: 'ObratyDilnyDlePracovnika', path: 'ObratyDilnyDlePracovnika', component: ObratyDilnyDlePracovnika },
], (route) => ({ ...route, meta: { objectName: NAME } }));
